import React from 'react';
import AdminReports from '../admin/Reports';

// Super Admin Reports page - reuses the same component as Admin Reports
// The component automatically handles permissions based on user role
const SuperAdminReports = () => {
  return <AdminReports />;
};

export default SuperAdminReports;
